import { Component, OnInit, Input } from '@angular/core';

interface INoResultsData {
  type: string;
  message: string;
}

@Component({
  selector: 'app-no-results',
  templateUrl: './no-results.component.html',
  styleUrls: ['./no-results.component.css']
})
export class NoResultsComponent implements OnInit {
  @Input() data: INoResultsData = {
    type: "unexpected",
    message: "Tuvimos un problema, por favor, inténtalo más tarde." 
  }

  constructor() { }

  ngOnInit(): void {
  }

}
